<div
  class="py-xl md:py-2xl flex flex-col md:flex-row items-center print:flex-row flex-wrap {{
    extraClass
  }}"
  [ngClass]="{ 'border-b border-ui-separator': withBorder }"
>
  <div
    class="flex-1 flex flex-col md:pr-base w-full"
    [ngClass]="{ 'mb-lg md:mb-0': contentSlot.children.length }"
  >
    <div class="text-xl leading-xl font-semibold text-txt capitalize {{ titleClass }}">{{ title }}</div>
    <div class="flex items-center gap-sm">
      <div #subTitleSlot>
        <ng-content select="[slot=subTitle]"></ng-content>
      </div>
      @if (subTitleSlot.children.length && showTaxInfoTooltip) {
        <mg-info-tooltip
          class="print:hidden {{ taxInfoTooltipExtraClass }}"
          iconClass="!text-sm"
          [description]="taxInfoTooltipDescription"
        ></mg-info-tooltip>
      }
    </div>
    @if (!subTitleSlot.children.length && subTitle) {
      <div class="flex items-center justify-between md:justify-start gap-sm mt-2xs">
        <div class="text-base leading-base text-txt">
          {{ subTitle }}
        </div>
        @if (showTaxInfoTooltip) {
          <mg-info-tooltip
            class="print:hidden {{ taxInfoTooltipExtraClass }}"
            iconClass="!text-sm"
            [description]="taxInfoTooltipDescription"
          ></mg-info-tooltip>
        }
      </div>
    }
  </div>

  <div class="w-full md:w-auto" #contentSlot>
    <ng-content></ng-content>
  </div>
</div>
